<template>
	<div v-if="show" class="user-info" :style="{ left: pos.x + 'px', top: pos.y + 'px' }" @click.stop>
		<div class="user-card">
			<profile-summary
				:avatar-name="displayName"
				:avatar-url="user.headImageThumb"
				:avatar-size="58"
				:title="displayName"
				:meta-items="profileMetaItems"
			>
				<template #avatar>
					<head-image
						:name="displayName"
						:url="user.headImageThumb"
						:size="58"
						:online="user.online"
						radius="50%"
						@click.native="showFullImage()"
					></head-image>
				</template>
				<template #title-extra>
					<i v-if="user.sex == 0" class="el-icon-male gender-icon male"></i>
					<i v-if="user.sex == 1" class="el-icon-female gender-icon female"></i>
				</template>
				<template #extra>
					<div class="user-id-row" :title="user.userName">
						<span class="label">ID</span>
						<span class="value">{{ user.userName }}</span>
						<button class="copy-btn" type="button" title="复制用户ID" @click="copyUserName">
							<i class="el-icon-copy-document"></i>
						</button>
					</div>
				</template>
			</profile-summary>

			<div v-if="isFriend && !isSelf" class="remark-section">
				<div class="remark-label">
					<i class="el-icon-edit-outline"></i>
					<span>备注</span>
				</div>
				<el-input
					v-if="isEditingRemark"
					ref="remarkInput"
					v-model="remarkValue"
					size="mini"
					maxlength="32"
					:disabled="isBusy"
					placeholder="请输入备注"
					@blur="saveRemark"
					@keyup.enter.native="saveRemark"
				></el-input>
				<button
					v-else
					type="button"
					class="remark-display"
					:disabled="isBusy"
					:title="friendRemark || '未设置'"
					@click="startEditRemark"
				>
					<span v-if="friendRemark">{{ friendRemark }}</span>
					<span v-else class="remark-placeholder">未设置</span>
					<i class="el-icon-edit-outline"></i>
				</button>
			</div>

			<div class="action-section">
				<el-button
					v-if="isFriend"
					type="primary"
					size="mini"
					class="action-btn"
					icon="el-icon-position"
					@click="onSendMessage()">
					发消息
				</el-button>
				<div v-else-if="isWaitingApprove" class="wait-status">
					<i class="el-icon-time"></i>
					<span>好友验证中</span>
				</div>
				<el-button
					v-else-if="user.id != mine.id"
					type="primary"
					plain
					size="mini"
					class="action-btn"
					icon="el-icon-plus"
					@click="onAddFriend()">
					加好友
				</el-button>
			</div>
		</div>
		<friend-apply ref="applyRef"></friend-apply>
	</div>
</template>

<script>
import FriendApply from '../friend/FriendApply.vue';
import HeadImage from './HeadImage.vue';
import ProfileSummary from './ProfileSummary.vue';

export default {
	name: "UserInfo",
	components: {
		HeadImage,
		FriendApply,
		ProfileSummary
	},
	data() {
		return {
			show: false,
			user: {},
			isEditingRemark: false,
			remarkValue: '',
			pendingAction: '',
			viewportGap: 10,
			pos: {
				x: 0,
				y: 0
			}
		}
	},
	mounted() {
		window.addEventListener('resize', this.onViewportChange);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onViewportChange);
	},
	methods: {
		open(user, pos) {
			this.show = true;
			this.user = user || {};
			this.isEditingRemark = false;
			this.remarkValue = '';
			this.pendingAction = '';
			this.pos.x = pos.x;
			this.pos.y = pos.y;
			this.$nextTick(() => {
				this.adjustPos();
			});
		},
		close() {
			this.show = false;
		},
		onViewportChange() {
			if (!this.show) {
				return;
			}
			this.adjustPos();
		},
		adjustPos() {
			const panel = this.$el;
			if (!panel) {
				return;
			}
			const rect = panel.getBoundingClientRect();
			const maxY = window.innerHeight - rect.height - this.viewportGap;
			const maxX = window.innerWidth - rect.width - this.viewportGap;
			this.pos.y = Math.max(this.viewportGap, Math.min(this.pos.y, maxY));
			this.pos.x = Math.max(this.viewportGap, Math.min(this.pos.x, maxX));
		},
		onSendMessage() {
			let user = this.user;
			let chat = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: user.nickName || user.userName,
				headImage: user.headImageThumb,
				userName: user.userName || ''
			};
			if (this.isFriend) {
				chat.showName = this.friendInfo.showNickName || this.friendInfo.nickName || this.friendInfo.userName || chat.showName;
				chat.userName = this.friendInfo.userName || chat.userName;
			}
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(chat);
			if (this.$route.path != "/home/chat") {
				this.$router.push("/home/chat");
			}
			this.show = false;
		},
		onAddFriend() {
			this.$refs.applyRef.open(this.user);
		},
		async runPendingAction(actionKey, handler) {
			if (this.pendingAction) {
				return false;
			}
			this.pendingAction = actionKey;
			try {
				await handler();
				return true;
			} finally {
				if (this.pendingAction === actionKey) {
					this.pendingAction = '';
				}
			}
		},
		startEditRemark() {
			if (!this.isFriend || this.isSelf || this.pendingAction) {
				return;
			}
			this.isEditingRemark = true;
			this.remarkValue = this.friendRemark;
			this.$nextTick(() => {
				if (this.$refs.remarkInput && this.$refs.remarkInput.focus) {
					this.$refs.remarkInput.focus();
				}
			});
		},
		saveRemark() {
			if (!this.isFriend || this.isSelf) {
				return;
			}
			if (this.pendingAction) {
				return;
			}
			const newRemark = String(this.remarkValue || '').trim();
			if (newRemark === this.friendRemark) {
				this.isEditingRemark = false;
				return;
			}
			this.runPendingAction('remark', async () => {
				const friend = await this.$http({
					url: '/friend/update/remark',
					method: 'PUT',
					data: {
						friendId: this.user.id,
						remarkNickName: newRemark
					}
				});
				this.friendStore.updateFriend(friend);
				this.groupStore.syncGroupMemberFromFriend(friend);
				this.chatStore.updateChatFromFriend(friend);
				this.$message.success(newRemark ? '备注设置成功' : '备注已清除');
			}).catch(() => {
				this.$message.error('备注保存失败，请重试');
			}).finally(() => {
				this.isEditingRemark = false;
			});
		},
		showFullImage() {
			if (this.user.headImage) {
				this.$eventBus.$emit("openFullImage", {
					url: this.user.headImage,
					strict: true
				});
			}
		},
		copyUserName() {
			const userName = this.user.userName;
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(userName).then(() => {
					this.$message.success(`内容'${userName}'已复制到剪贴板`);
				}).catch(() => {
					this.$message.error('复制失败，请手动复制');
				});
				return;
			}
			this.$message.error('复制失败，请手动复制');
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		isSelf() {
			return this.user && this.mine && this.user.id == this.mine.id;
		},
		isFriend() {
			return this.friendStore.isFriend(this.user.id);
		},
		friendInfo() {
			return this.friendStore.findFriend(this.user.id);
		},
		displayName() {
			if (this.isFriend && this.friendInfo) {
				return this.friendInfo.showNickName || this.friendInfo.nickName || this.friendInfo.userName || this.user.nickName || this.user.userName || '';
			}
			return this.user.nickName || this.user.userName || '';
		},
		friendRemark() {
			return this.friendInfo && this.friendInfo.remarkNickName ? this.friendInfo.remarkNickName : '';
		},
		isBusy() {
			return Boolean(this.pendingAction);
		},
		isWaitingApprove() {
			return this.friendStore.isInRecvRequest(this.user.id);
		},
		profileMetaItems() {
			const items = [];
			if (this.statusText) {
				items.push({
					icon: this.statusIcon,
					text: this.statusText,
					className: 'danger'
				});
			}
			return items;
		},
		statusText() {
			if (this.user.status == 1) {
				return '已注销';
			}
			if (this.user.isBanned) {
				return '已封禁';
			}
			return '';
		},
		statusIcon() {
			if (this.isStatusDanger) {
				return 'el-icon-warning-outline';
			}
			return 'el-icon-success';
		},
		isStatusDanger() {
			return this.user.status == 1 || this.user.isBanned;
		}
	}
}
</script>

<style scoped lang="scss">
.user-info {
	position: fixed;
	width: min(296px, calc(100vw - 20px));
	background: var(--im-card-bg-90, rgba(255, 255, 255, 0.96));
	backdrop-filter: blur(18px);
	border-radius: 12px;
	box-shadow: 0 18px 36px -28px rgba(var(--im-black-rgb), 0.4);
	border: 1px solid var(--im-surface-panel-border);
	z-index: 9999;
	overflow: hidden;

	.user-card {
		padding: 14px;
	}

	.gender-icon {
		flex-shrink: 0;
		font-size: 13px;
		padding: 3px;
		border-radius: 999px;

		&.male {
			color: var(--im-color-primary);
			background: rgba(var(--im-primary-rgb), 0.1);
		}

		&.female {
			color: var(--im-color-danger);
			background: rgba(var(--im-danger-rgb, 245, 34, 45), 0.1);
		}
	}

	.user-id-row {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-top: 8px;
		padding: 8px 10px;
		border-radius: 8px;
		background: var(--im-control-soft-bg);
		border: 1px solid var(--im-control-border);
		font-size: 12px;
		line-height: 1;

		.label {
			flex-shrink: 0;
			color: var(--im-text-color-light);
		}

		.value {
			flex: 1;
			min-width: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-family: 'Courier New', monospace;
			color: var(--im-text-color);
		}
	}

	.copy-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 24px;
		height: 24px;
		flex-shrink: 0;
		border: none;
		border-radius: 6px;
		background: transparent;
		color: var(--im-color-primary);
		cursor: pointer;
		transition: background 0.2s ease, color 0.2s ease;

		&:hover {
			background: rgba(var(--im-primary-rgb), 0.08);
		}
	}

	.remark-section {
		display: flex;
		flex-direction: column;
		gap: 7px;
		margin-top: 14px;
		padding: 10px;
		border-radius: 8px;
		background: var(--im-control-soft-bg);
		border: 1px solid var(--im-control-border);
		color: var(--im-text-color);

		:deep(.el-input__inner) {
			height: 32px;
			line-height: 32px;
			border-radius: 7px;
			font-size: 12px;
		}
	}

	.remark-label {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 12px;
		font-weight: 600;
		color: var(--im-text-color-light);

		i {
			font-size: 13px;
			color: var(--im-color-primary);
		}
	}

	.remark-display {
		width: 100%;
		min-height: 32px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 8px;
		padding: 0 9px;
		border: none;
		border-radius: 7px;
		background: var(--im-card-bg-90, rgba(var(--im-white-rgb), 0.9));
		color: var(--im-text-color);
		text-align: left;
		cursor: pointer;
		transition: background 0.2s ease;

		&:hover {
			background: var(--im-control-soft-bg-hover);
		}

		&:disabled {
			cursor: not-allowed;
			opacity: 0.72;
		}

		span {
			flex: 1;
			min-width: 0;
			font-size: 12px;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		i {
			flex-shrink: 0;
			font-size: 13px;
			color: var(--im-color-primary);
		}
	}

	.remark-placeholder {
		color: var(--im-text-color-light);
	}

	.action-section {
		margin-top: 14px;
		padding-top: 14px;
		border-top: 1px solid rgba(var(--im-black-rgb), 0.08);
	}

	.action-btn {
		width: 100%;
		height: 36px;
		border-radius: 8px;
		font-weight: 600;
	}

	.wait-status {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		height: 36px;
		padding: 0 12px;
		border-radius: 8px;
		background: var(--im-control-soft-bg);
		border: 1px solid var(--im-control-border);
		color: var(--im-text-color-light);
		font-size: 12px;

		i {
			color: var(--im-color-primary);
			font-size: 13px;
		}
	}
}

@media (max-width: 640px) {
	.user-info {
		width: calc(100vw - 16px);

		.user-card {
			padding: 12px;
		}
	}
}
</style>
